import type {
  DeliveryChargeRuleUpdateRequestType,
  DeliveryChargeRuleUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDeliveryChargeRuleUpdate = (deliveryChargeRuleId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: DeliveryChargeRuleUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `delivery-charge-rules/${deliveryChargeRuleId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as DeliveryChargeRuleUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.DeliveryChargeRules],
      });
    },
  });
};
